import React, {FC, useEffect} from 'react';
import {useAction} from "../../../../../store/hooks/useAction";
import {useTypedSelector} from "../../../../../store/hooks/useTypedSelector";
import {Accordion} from "react-bootstrap";
import {Link} from "react-router-dom";

interface STLProps {
    atagParams: string | null
    viewType?: string | null
    eventKey: string

    ticketOpenMode: string | null
    sourceParams: string | null,
}
const QuickbetLobbyWidget: FC <STLProps> = ({atagParams, viewType,eventKey,ticketOpenMode, sourceParams}) => {
    const {getQuickbetsData} = useAction();
    const {quickbetsData} = useTypedSelector((state) => state.quickbetsReducer);
    const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;
    useEffect(()=>{
        getQuickbetsData();
    }, [])
    return(
        <>
            {quickbetsData.length > 0 ?
                <Accordion.Item eventKey={eventKey} className='cursor-pointer'>
                    <Accordion.Header>Quickbet</Accordion.Header>
                    <Accordion.Body>
                        <ul
                            style={{
                                listStyle: 'none',
                                padding: '0'
                            }}
                        >
                            {
                                quickbetsData.length > 0 ?
                                    quickbetsData.map((item: any, index: number) => {
                                        return (
                                            <li key={`${index}quickbetData`} className='mt-1'>
                                                <Link
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'left',
                                                        alignItems: ' center'
                                                    }}
                                                    to={(() => {
                                                        let url = `quickbet/${item.code}`;
                                                        const params = new URLSearchParams();

                                                        if (atagParams) params.append('atag', atagParams);
                                                        if (sourceParams) params.append('source', sourceParams);
                                                        if (viewType) params.append('viewType', viewType);
                                                        const queryString = params.toString();
                                                        if (queryString) url += `?${queryString}`;

                                                        return url;
                                                    })()}
                                                    className='smartbet-card-link text-decoration-none  sidebar-ticket-link'
                                                    target={ticketOpenMode === 'redirect' ? '_blank' : undefined}
                                                >
                                                    <img
                                                        src={`${item.preview_img}`}
                                                        onError={(e) => {
                                                            e.currentTarget.src = toAbsoluteUrl('/assets/img/events/league/F2964C.png');
                                                        }}
                                                        width='35'
                                                        height='35'
                                                        alt="QBX-logo"
                                                        style={{
                                                            borderRadius: "1rem"
                                                        }}
                                                    />
                                                    <div style={{marginLeft: '10px'}}
                                                         className='text-center text-green'>
                                                        {item.title.length > 0 ? item.title : null}
                                                    </div>
                                                </Link>
                                            </li>
                                        )
                                    }) : null
                            }
                        </ul>
                    </Accordion.Body>
                </Accordion.Item>
                : null
            }
        </>
    )

}

export default QuickbetLobbyWidget;
